/* Hyper Cyber accessibility helpers: make custom-element controls
   (cart remove, side panel close) behave like real buttons for keyboard
   and screen-reader users. */
(() => {
  const SELECTOR = 'cart-remove, side-panel-close';
  const enhance = (el) => {
    if (el.dataset.hcA11y) return;
    el.dataset.hcA11y = '1';
    if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (!el.hasAttribute('aria-label')) {
      el.setAttribute('aria-label', el.matches('cart-remove') ? 'Remove item from cart' : 'Close');
    }
    el.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        el.click();
      }
    });
  };
  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches(SELECTOR)) enhance(root);
    root.querySelectorAll(SELECTOR).forEach(enhance);
  };
  scan(document.body);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach(scan));
  }).observe(document.body, { childList: true, subtree: true });
})();
